/**
 * Build-time configuration.
 *
 * Nx exposed `process.env.NX_*`; Vite exposes `import.meta.env.VITE_*`. Both
 * default to same-origin paths, so a dev build talks to Vite's proxy and a
 * production build talks to Caddy — neither needs CORS, and there is no host
 * baked in that could point at the wrong environment.
 */

const env = import.meta.env;

function socketUrl(): string {
  if (env.VITE_SOCKET_URL) return env.VITE_SOCKET_URL;
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/ws/mobile`;
}

export const appConfig = {
  socketUrl: socketUrl(),
  /** Empty means same-origin, which is what both dev and production use. */
  apiUrl: env.VITE_API_URL ?? ''
};
